
import Vue from 'vue';
export default Vue.extend({
  props: ['content', 'icon', 'title', 'color', 'link'],
});
